import React, { Component } from 'react';
import Banner from '../Common/Banner';
import call from "../Core/Services";

import DocumentMeta from 'react-document-meta';

class Contact extends React.Component {
	
    constructor( props ) {
        super( props );

        this.state = {
            message : ''
        };

    }

    submitForm = ( e ) => {
        
        e.preventDefault();

        let formData = {
            'name'      : this.refs.fullName.value,
            'email'     : this.refs.email.value,
            'phone'     : this.refs.phone.value,
            'comment'   : this.refs.comment.value,
            'category'  : 'CONTACT',
        };

        call.submitForm( formData, () => {
            
            this.refs.fullName.value    = '';
            this.refs.email.value       = '';
            this.refs.phone.value       = '';
            this.refs.comment.value     = '';
    
            this.setState({
                message: 'Tak for din besked, vi svarer som regel i løbet af få timer'
            });

            setTimeout( () => {                
                this.setState({
                    message: ''
                });
            }, 10000)

        });

    }

    render() {

		// see https://developers.google.com/maps/documentation/javascript 
        //const googleMapsApiKey = '	AIzaSyA_KyStalOgeIGjGtcV7jkXBubJQOn6BzQ';
    
        const meta = {
            title:          'Hvis du har et spørgsmål',
            description:    'I København er cykel en del af vores hverdag, hvis du gerne vil leve som en sand københavner kan du ikke undgå din cykel. Men hvad gør du når din cykel er til reparation eller mangler du bare en cykel for få dage?. Alaska cykler har den billigste løsning til denne udfordring.',
            canonical:      window.location.href,
            meta: {
                charset:    'utf-8',
                name: {
                    keywords: 'cykeludlejning i københavn, billige cykler til leje, leje en cykel københavn'
                }
            }
        };

        return (
			<div className="contact-page">
                
                <DocumentMeta {...meta} />

                <Banner 
					pageName='Kontakt Os' 
					pageID='contact' 
					pageDesc='Hvis du har et spørgsmål' 
					url='http://res.cloudinary.com/dttrnjoc5/image/upload/c_fill,h_800,q_50,w_1600/v1510589481/backgrounds/cf_silhouettes.jpg' />

                <div className="scroll-stop"></div>

                <div className="t-row">
                    <div className="t-col-40 top t-col-100-tablet">
                        <div className="med-pad">
                            <h3 className="sec-head padding-bottom">Kontakt Os</h3> 

                            <div className={ this.state.message ? 'alert alert-success show' : 'alert alert-success' }>
                                <a className="close" onClick={ () => this.setState({message: '' }) } >&times;</a>
                                { this.state.message }
                            </div>

                            <form role="form" id="contact-form" onSubmit={ this.submitForm } method="post" >
                                
                                <div className="row">
                                    <div className="form-group col-md-6">
                                        <label className="sr-only" htmlFor="first-name">Navn</label>
                                        <input ref="name" type="text" ref="fullName" required name="first-name" placeholder="Navn" minLength={3} maxLength={15} className="form-control" />
                                        <span className="error" />
                                    </div>
                                    <div className="form-group col-md-6">
                                        
                                        <label className="sr-only" htmlFor="phone-number">Telefonnummer</label>
                                        <input ref="phone" type="number" ref="phone" required name="phone-number" placeholder="Telefonnummer" className="form-control" />
                                        <span className="error" />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="form-group col-md-12">
                                        <label className="sr-only" htmlFor="email">Email adresse</label>
                                        <input ref="email" type="email" required ref="email" name="email" placeholder="Email adresse" minLength={3} maxLength={50} className="form-control" />
                                        <span className="error" />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="form-group col-sm-12">
                                        <label className="sr-only">Forespørgselsdetaljer</label>
                                        <textarea ref="message" required ref="comment" name="enquiry_details" className="form-control" minLength={10} maxLength={300} rows={5} placeholder="Indtast din forespørgsel her..." />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="form-group col-xs-4">
                                        <input type="submit" name="Submit" className="btn btn-primary btn-block" defaultValue="Indsend" />
                                    </div>
                                </div>
                                                                
                            </form>

                            <h3 className="sec-head padding-bottom">Kontakt Adresse</h3>
                            <p>
                                Islevhusvej 7, 2700 Brønshøj, <br />
                                CVR: 38971069<br />
                                TLF: 71873167<br />
                                alaskacykler@mail.com
                            </p>
                        </div>
                    </div>
                    <div className="t-col-60 top t-col-100-tablet">
                        
                        {
                            /*

                            <ReactStreetview
                                apiKey={googleMapsApiKey}
                                streetViewPanoramaOptions={streetViewPanoramaOptions} />

                            */
                        }
                        
                        <div className="google-map">
                            <iframe 
                                src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d7560.621761616126!2d12.45867759520137!3d55.710086285166014!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x46525198fb24a793%3A0xeee9996ee24762b!2salaska+cykler!3m2!1d55.7113902!2d12.4717753!5e0!3m2!1sen!2sin!4v1511686769385" 
                                width="600" 
                                height="450" 
                                frameborder="0" 
                                style={{border:0}} 
                                allowfullscreen></iframe>
                        </div>

                    </div>
                </div>

				

			</div>
		);
	}
}

export default Contact;



// WEBPACK FOOTER //
// ./src/Pages/Contact.js